// extracted by mini-css-extract-plugin
export default {"container":"stampDuty_container__vo0cJ","wrapper":"stampDuty_wrapper__dTKmY","box":"stampDuty_box__7kcfD","speshButton":"stampDuty_speshButton__wUd7S"};